<app-floorplan-product-menu
  [title]="tooltipTextUtility"
  [hasConfigurations]="utilities.length > 0"
  [visible]="floorplan.floorplanState.utilitiesVisible"
  [locked]="floorplan.floorplanState.utilitiesLocked"
  [itemTextVisible]="floorplan.floorplanState.utilitiesItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.utilitiesVisible = $event"
  (lockUpdate)="floorplan.floorplanState.utilitiesLocked = $event"
  (itemTextVisibilityUpdate)="updateUtilitiesItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="utility"
>
  @for (utility of utilities; track utility) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="utility"
        [imageUrl]="(getImageUrl$(utility) | async) || fallbackImageUrl"
        [fallbackImageUrl]="fallbackImageUrl"
        [numberOfFloorplanItems]="floorplan.countPlacedUtilities(utility)"
        [attachments]="[]"
        (add)="addUtility(utility)"
        (delete)="deleteUtility(utility)"
        (dragStart)="drag(utility)"
        editPath="utility"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
